import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Tooltip,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../lib/auth";
import { jwtDecode } from "jwt-decode";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArticleIcon from "@mui/icons-material/Article";

const Header = () => {
  const [selectedIcon, setSelectedIcon] = useState(null); // 選択されたアイコンを管理

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ユーザー名取得（トークンから）
  let username = null;
  const token = localStorage.getItem("accessToken");
  if (token) {
    try {
      const decoded = jwtDecode(token);
      const email = decoded.email || (decoded.sub && decoded.sub.email);
      if (email) {
        username = email.split("@")[0];
      }
    } catch (e) {
      console.error("JWTデコードに失敗:", e);
    }
  }

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleArticleClick = () => {
    setSelectedIcon("article"); // Articleアイコンが選択されたことを記録
    navigate("/"); // 遷移先をHome画面に
  };

  const handleRankingClick = () => {
    setSelectedIcon("ranking"); // ランキングアイコンが選択されたことを記録
    navigate("/ranking");
  };

  const handleFavoritesClick = () => {
    setSelectedIcon("favorites"); // お気に入りアイコンが選択されたことを記録
    navigate("/favorites"); // お気に入りページに遷移
  };

  return (
    <AppBar position="static" elevation={0} color="transparent">
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* 左側：ロゴ & ユーザー名 */}
        <Box>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, cursor: "pointer", textDecoration: "none" }}
            component={Link}
            to="/"
            color="inherit"
          >
            Gl AI News
          </Typography>
          <Typography variant="caption" sx={{ ml: 1 }}>
            {username ? `${username}` : "未ログイン"}
          </Typography>
        </Box>

        {/* 右側：機能アイコン（モバイルでも表示崩れしにくい） */}
        <Box sx={{ display: "flex", alignItems: "center", gap: isMobile ? 1 : 2 }}>
          {/* ニュース記事アイコン */}
          <Tooltip title="ニュース速報">
            <IconButton
              onClick={handleArticleClick}
              color={selectedIcon === "article" ? "error" : "inherit"} // 選択時に赤色（Filledアイコン）
            >
              <ArticleIcon
                color={selectedIcon === "article" ? "error" : "inherit"} // 選択時に赤色、非選択時に黒色
              />
            </IconButton>
          </Tooltip>

          {/* ランキングアイコン */}
          <Tooltip title="ランキング">
            <IconButton
              onClick={handleRankingClick}
              color={selectedIcon === "ranking" ? "error" : "inherit"} // 選択時に赤色（Filledアイコン）
            >
              <EmojiEventsIcon
                color={selectedIcon === "ranking" ? "error" : "inherit"} // 選択時に赤色、非選択時に黒色
              />
            </IconButton>
          </Tooltip>

          {!username && (
            <>
              <Tooltip title="サインアップ">
                <IconButton component={Link} to="/signup" color="inherit">
                  <PersonAddIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="ログイン">
                <IconButton component={Link} to="/login" color="inherit">
                  <LoginIcon />
                </IconButton>
              </Tooltip>
            </>
          )}

          {username && (
            <>
              <Tooltip title="お気に入り">
                <IconButton
                  onClick={handleFavoritesClick}
                  color={selectedIcon === "favorites" ? "error" : "inherit"} // 選択時に赤色
                >
                  <FavoriteIcon
                    color={selectedIcon === "favorites" ? "error" : "inherit"} // 選択時に赤色、非選択時に黒色
                  />
                </IconButton>
              </Tooltip>

              <Tooltip title="ログアウト">
                <IconButton onClick={handleLogout} color="inherit">
                  <LogoutIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
